import apiFetch from '../apiFetch'

export default function (token, search) {
  return apiFetch({ endPoint: 'Faq/Search', method: 'POST', token: token, body: search })
}
